import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { api, IDR } from "@/lib/api";

export default function OrderConfirm() {
  const { orderNumber } = useParams();
  const [params] = useSearchParams();
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.post("/orders/track", { order_number: orderNumber, contact: params.get("email") || "" })
      .then((r) => setOrder(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || "Gagal memuat"));
  }, [orderNumber]);

  if (err) return <div className="p-16 text-center text-neutral-400">{err}</div>;
  if (!order) return <div className="p-16 text-center text-neutral-500">Memuat...</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16 fade-in-up">
      <div className="status-badge">ORDER CONFIRMED</div>
      <h1 className="display text-5xl md:text-7xl mt-4">TERIMA KASIH</h1>
      <p className="text-neutral-400 mt-3">Pesanan kamu telah kami terima dan akan segera diproses.</p>

      <div className="mt-8 border border-[color:var(--border)] p-6">
        <div className="flex justify-between mb-4">
          <div>
            <div className="text-[10px] text-neutral-500 tracking-widest">ORDER NUMBER</div>
            <div data-testid="order-number" className="display text-3xl">{order.order_number}</div>
          </div>
          <div className="text-right">
            <div className="text-[10px] text-neutral-500 tracking-widest">STATUS PEMBAYARAN</div>
            <div data-testid="pay-status" className="display text-3xl">{order.payment_status}</div>
          </div>
        </div>

        <div className="space-y-3">
          {order.items.map((it, i) => (
            <div key={i} className="flex justify-between border-b border-[color:var(--border)] py-2 text-sm">
              <div>
                <div className="text-[10px] text-neutral-500">{it.article_code}</div>
                <div>{it.name} — {it.color} / {it.size} × {it.qty}</div>
              </div>
              <div className="tabular-nums">{IDR(it.line_total)}</div>
            </div>
          ))}
        </div>
        <div className="mt-4 space-y-1 text-sm">
          <div className="flex justify-between"><span>Subtotal</span><span className="tabular-nums">{IDR(order.subtotal)}</span></div>
          {order.discount_amount > 0 && (
            <div className="flex justify-between text-emerald-400"><span>Diskon ({order.discount_code})</span><span className="tabular-nums">− {IDR(order.discount_amount)}</span></div>
          )}
          <div className="flex justify-between"><span>Ongkir {order.shipping_origin_city ? `(${order.shipping_origin_city})` : ""}</span><span className="tabular-nums">{IDR(order.shipping)}</span></div>
          {order.shipping_eta_min_days && (
            <div className="flex justify-between text-[11px] text-neutral-400">
              <span>Estimasi tiba</span>
              <span>{order.shipping_eta_min_days}–{order.shipping_eta_max_days} hari kerja</span>
            </div>
          )}
          <div className="flex justify-between display text-2xl mt-2"><span>TOTAL</span><span className="tabular-nums">{IDR(order.total)}</span></div>
        </div>
      </div>

      <div className="flex gap-3 mt-8">
        <Link to="/shop" className="border border-white px-6 py-3 text-xs tracking-widest">LANJUT BELANJA</Link>
        <Link to="/track" className="bg-white text-black px-6 py-3 text-xs tracking-widest">LACAK PESANAN</Link>
      </div>
    </div>
  );
}
